import React, { useState } from 'react';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { useToolContext } from 'contexts/ToolContext';

function ToolSelector() {
    const { lstTool, selectedTool, selectedToolName, setSelectedTool, isLoading } = useToolContext();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);

    if (isLoading || lstTool.length === 0) {
        return null;
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} className="tool-selector">
            <DropdownToggle
                caret
                style={{
                    background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                    border: 'none',
                    color: '#fff',
                    fontWeight: '600',
                    fontSize: '14px',
                    borderRadius: '20px',
                    padding: '7px 16px',
                    boxShadow: '0 2px 8px rgba(52,152,219,0.3)'
                }}
            >
                {selectedToolName || 'Chọn phần mềm'}
            </DropdownToggle>
            <DropdownMenu>
                {lstTool.map((tool, key) => {
                    const isActive = selectedTool === tool.matool;
                    return (
                        <DropdownItem
                            key={key}
                            active={isActive}
                            onClick={() => setSelectedTool(tool.matool, tool.name, true)}
                            style={isActive ? {
                                backgroundColor: '#3498db',
                                color: '#fff',
                                fontWeight: 'bold'
                            } : {}}
                        >
                            {tool.name}
                        </DropdownItem>
                    );
                })}
            </DropdownMenu>
        </Dropdown>
    );
}

export default ToolSelector;
